import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class BillersResolver implements Resolve<boolean> {
  constructor(private httpClient: HttpClient, private router: Router, private authService: AuthService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    const navigation = this.router.getCurrentNavigation();
    const extras = navigation?.extras.state as { category?: string };
    let url;
    if (extras && extras.category) {
      let category = extras.category;
      url = '/api/billers?category=' + category;
    } else {
      url = '/api/billers';
    }
    return this.httpClient.get(url, { headers: new HttpHeaders().append('Authorization','Bearer ' + this.authService.token)});
  }
}
